import { EventRefType, EXTERNAL_CAMPAIGN } from "@/core/event"
import { ParseUriResult } from "@/utils/parseuri"
import settings from "./settings"

const params = ["utm_campaign", "utm_content", "utm_term", "utm_medium", "utm_source"]

export function campaignEvent(currentUri: ParseUriResult) {
  const target = params.map(param => currentUri.searchParams.get(param)).find(Boolean)
  if (target) {
    return { type: EXTERNAL_CAMPAIGN, target } as const
  }
}

export function isCustomCampaign(currentUri: ParseUriResult, segmentUrlParameters: string[]) {
  return segmentUrlParameters && segmentUrlParameters.find(el => currentUri.searchParams.get(el))
}

export function adWordEvent(currentUri: ParseUriResult) {
  if (currentUri.searchParams.get("gclid")) {
    return { type: EXTERNAL_CAMPAIGN, target: currentUri.searchParams.get("gclid")! } as const
  }
}

function searchQuery(currentUri: ParseUriResult, siteSearchQueryParameterName: string) {
  return currentUri.searchParams?.get(siteSearchQueryParameterName)
}

export function refType(currentUri: ParseUriResult, nostoSourceParameterName: string) {
  const param = currentUri.searchParams.get(nostoSourceParameterName)
  return param && settings.trackingTypes.includes(param) ? (param as EventRefType) : null
}

export function recommendationRef(currentUri: ParseUriResult, recommendationRefParamName: string) {
  return searchQuery(currentUri, recommendationRefParamName)
}

export function refMail(currentUri: ParseUriResult) {
  return currentUri.searchParams.get("refmail")
}
